import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchBomHeaders } from '@/api/my-styles';

export function bomHeadersQueryOptions(styleId: string) {
  return queryOptions({
    queryKey: ['my-styles', 'bom', 'headers', styleId] as const,
    queryFn: () =>
      fetchBomHeaders({
        styleId,
        page: 1,
        limit: 500,
        sort: 'createdAt',
        order: 'desc',
      }),
    enabled: Boolean(styleId),
  });
}

export function useBomHeaders(styleId: string) {
  return useQuery(bomHeadersQueryOptions(styleId));
}
